import React from 'react';
import ConnectionsTable from '../../shared/Tables/ConnectionsTable';


class Connections extends React.Component {

	render() {
		// console.log('connections: render');
		return (
			<div className="row">
			<div className="col-md-12">

				<h5>Connections</h5>
				<div className="card">
					<div className="card-header">
						<i className="fa fa-th-large"></i>
						Connections
					</div>

					<div className="card-block">
					<ConnectionsTable/>
					</div>
				</div>
			</div>
			</div>
		);
	}
}

export default Connections;